import React from 'react';

export default (
  <svg
    width="80"
    height="18"
    viewBox="0 0 80 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1757_35794)">
      <path
        d="M8.97353 0.0529785C4.02353 0.0529785 0 4.07651 0 9.02651C0 13.9765 4.02353 18 8.97353 18C13.9235 18 17.9471 13.9765 17.9471 9.02651C17.9471 4.07651 13.9235 0.0529785 8.97353 0.0529785ZM8.97353 11.25C7.75588 11.25 6.75 10.2706 6.75 9.02651C6.75 7.78239 7.72941 6.80298 8.97353 6.80298C10.2176 6.80298 11.1971 7.78239 11.1971 9.02651C11.1971 10.2442 10.1912 11.25 8.97353 11.25Z"
        fill="#7367E7"
      />
      <path
        d="M66.3617 0.0529785C61.4117 0.0529785 57.3882 4.07651 57.3882 9.02651C57.3882 13.9765 61.4117 18 66.3617 18C71.3117 18 75.3352 13.9765 75.3352 9.02651C75.3352 4.07651 71.3382 0.0529785 66.3617 0.0529785ZM66.3617 11.25C65.1441 11.25 64.1382 10.2706 64.1382 9.02651C64.1382 7.80886 65.1176 6.80298 66.3617 6.80298C67.6058 6.80298 68.5852 7.78239 68.5852 9.02651C68.5852 10.2706 67.6058 11.25 66.3617 11.25Z"
        fill="#7367E7"
      />
      <path
        d="M28.1383 11.2499C26.9207 11.2499 25.9148 10.244 25.9413 9.02637C25.9413 7.80873 26.9471 6.80285 28.1648 6.82932C29.0383 6.82932 29.8324 7.35873 30.203 8.17932H37.0854C36.6089 3.25579 32.2148 -0.370685 27.2913 0.105786C22.3677 0.582257 18.7413 4.97638 19.2177 9.89991C19.6942 14.8234 24.0883 18.4499 29.0118 17.9734C33.2736 17.5499 36.6618 14.1881 37.0854 9.89991H30.203C29.8324 10.7205 29.0383 11.2499 28.1383 11.2499Z"
        fill="#7367E7"
      />
      <path
        d="M48.0971 0.449951V7.9676H46.3765V0.449951H38.3295V17.6029H46.3765V10.1117H48.0971V17.6029H56.1442V0.449951H48.0971Z"
        fill="#7367E7"
      />
      <path
        d="M77.4001 0C76.2883 0 75.3883 0.9 75.3883 2.01176C75.3883 3.12353 76.2883 4.02353 77.4001 4.02353C78.5118 4.02353 79.4118 3.12353 79.4118 2.01176C79.4118 0.9 78.5118 0 77.4001 0ZM77.4001 3.67941C76.4736 3.67941 75.7324 2.93824 75.7324 2.01176C75.7324 1.08529 76.4736 0.344118 77.4001 0.344118C78.3265 0.344118 79.0677 1.08529 79.0677 2.01176C79.0677 2.93824 78.3265 3.67941 77.4001 3.67941ZM77.7971 2.17059C77.956 2.11765 78.1413 1.95882 78.1413 1.64118C78.1413 1.32353 77.9295 1.05882 77.506 1.05882H76.8177C76.7648 1.05882 76.7648 1.08529 76.7648 1.08529V2.93824C76.7648 2.96471 76.7913 2.96471 76.7913 2.96471H77.0295C77.056 2.96471 77.056 2.93824 77.056 2.93824V2.22353H77.453L77.7971 2.93824L77.8236 2.96471H78.1148C78.1413 2.96471 78.1413 2.93824 78.1413 2.93824C78.1413 2.93824 78.1413 2.93824 78.1413 2.91176L77.7971 2.17059ZM77.453 1.98529H77.0824V1.32353H77.453C77.6648 1.32353 77.8236 1.42941 77.8236 1.66765C77.8236 1.85294 77.6913 1.98529 77.453 1.98529Z"
        fill="#7367E7"
      />
    </g>
    <defs>
      <clipPath id="clip0_1757_35794">
        <rect width="79.4118" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
